/**
 * Cookie Consent Banner
 *
 * Handles Accept All / Reject Non-Essential button clicks.
 * Posts to the existing /customer_privacy/update_optin_optout endpoint
 * to set the httpOnly AllowSiteTracking cookie, then reloads the page.
 *
 * Auto-included in website bundle via gulp glob.
 * Only runs when the banner element exists on the page (no WebPageObj guard needed).
 */
(function() {
    var $banner = $('#cookieConsentBanner');
    if (!$banner.length) return;

    var $acceptBtn = $('#cookieConsentAccept');
    var $rejectBtn = $('#cookieConsentReject');
    var isSubmitting = false;

    function submitConsent(status) {
        if (isSubmitting) return;
        isSubmitting = true;

        $acceptBtn.prop('disabled', true);
        $rejectBtn.prop('disabled', true);

        $.ajax({
            url: '/customer_privacy/update_optin_optout',
            method: 'POST',
            data: { status: status },
            dataType: 'json',
            success: function() {
                location.reload();
            },
            error: function(xhr, status, error) {
                isSubmitting = false;
                $acceptBtn.prop('disabled', false);
                $rejectBtn.prop('disabled', false);

                $('#cookieConsentFeedback').html('Unable to save your preference. Please try again.');
                console.error('Consent submission failed:', status, error);
            }
        });
    }

    $acceptBtn.on('click', function() {
        submitConsent(1);
    });

    $rejectBtn.on('click', function() {
        submitConsent(0);
    });
})();
